import { createBrowserRouter, createRoutesFromElements, redirect, Route, RouterProvider } from 'react-router-dom';
import './App.css';
import RootLayout from './pages/RootLayout';
import Home from './pages/home';
import AllServices from './components/AllServices';
import CompanyCreated from './components/CompanyCreated';
import SupportServices from './components/SupportServices';
import MarktingServices from './components/MarktingServices';
import AccountingServices from './components/AccountingServices';
import PremiumResidency from './components/PremiumResidency';
import About from './pages/About';
import Us from './components/about/Us';
import OurServices from './components/about/OurServices';
import ContactUs from './components/about/ContactUs';
import ServicesOf from './pages/ServicesOf';
import ConServices from './components/services/all/ConServices';
import TraQual from './components/services/all/TraQual';
import NajizServices from './components/services/all/NajizServices';
import SaberServices from './components/services/all/SaberServices';
import CivilDefense from './components/services/all/CivilDefense';
import MedicalServices from './components/services/all/MedicalServices';
import MadadServices from './components/services/all/MadadServices';
import ProfessionalLicense from './components/services/all/ProfessionalLicense';
import AgriculturalLicense from './components/services/companyCrea/AgriculturalLicense';
import ProfLicenseSaudPartner from './components/services/companyCrea/ProfLicenseSaudPartner';
import TransportActivitiesLice from './components/services/companyCrea/TransportActivitiesLice';
import ForComLice from './components/services/companyCrea/ForComLice';
import CoiLisSauPar from './components/services/companyCrea/CoiLisSauPar';
import ProLic from './components/services/companyCrea/ProLic';
import IndLic from './components/services/companyCrea/IndLic';
import UniRes from './components/services/premiumServ/UniRes';
import InvBizRes from './components/services/premiumServ/InvBizRes'
import ProOwnRes from './components/services/premiumServ/ProOwnRes';
import TalRes from './components/services/premiumServ/TalRes';
import EntRes from './components/services/premiumServ/EntRes';
import ExcepRes from './components/services/premiumServ/ExcepRes';
import ManOrgEvCon from './components/services/markting/ManOrgEvCon';
import ActTabTam from './components/services/markting/ActTabTam';
import DevWeb from './components/services/markting/DevWeb';
import UpMap from './components/services/markting/UpMap';
import RaiBra from './components/services/markting/RaiBra';
import ManOrgEst from './components/services/markting/ManOrgEst';
import ProPho from './components/services/markting/ProPho';
import BooAccRec from './components/services/acounting/BooAccRec';
import AccSysPer from './components/services/acounting/AccSysPer';
import WarInvMan from './components/services/acounting/WarInvMan';
import ProAccCon from './components/services/acounting/ProAccCon';
import ProAccSys from './components/services/acounting/ProAccSys';
import PreTaxDec from './components/services/acounting/PreTaxDec';
import ManSocAcc from './components/services/markting/ManSocAcc';
import PreFinAdmFin from './components/services/acounting/PreFinAdmFin';
import SetTraAcc from './components/services/acounting/SetTraAcc';
import ErrorPage from './pages/ErrorPage';
import Programming from './components/Programming';
import Intellpropservices from './components/Intellpropservices';
import AppDev from './components/services/programming/AppDev';
import Web from './components/services/programming/Web';
import TechnicalSupport from './components/services/programming/TechnicalSupport';
import Hr from './components/services/programming/Hr';
import AccountSystem from './components/services/programming/AccountSystem';
import AdminSystem from './components/services/programming/AdminSystem';
import Crm from './components/services/programming/Crm';
import Trademarks from './components/services/Intellpropservices/Trademarks';
import Patent from './components/services/Intellpropservices/Patent';
import IndustrialProduct from './components/services/Intellpropservices/IndustrialProduct';
import Copyright from './components/services/Intellpropservices/Copyright';
import { HelmetProvider } from 'react-helmet-async';
function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route element={<RootLayout />}>
          <Route index loader={() => redirect('/home')} />
          <Route path='home' element={<Home />} >
            <Route index element={<AllServices />} />
            <Route path='all' element={<AllServices />} />
            <Route path='companycreated' element={<CompanyCreated />} />
            <Route path='supportservices' element={<SupportServices />} />
            <Route path='premiumresidency' element={<PremiumResidency />} />
            <Route path='marketingservices' element={<MarktingServices />} />
            <Route path='accountingservices' element={<AccountingServices />} />
            <Route path='programming' element={<Programming/>} />
            <Route path='intellpropservices' element={<Intellpropservices/>} />
          </Route>
          <Route path='about' element={<About/>}>
            <Route index element={<Us />} />
            <Route path='ourservices' element={<OurServices />} />
            <Route path='contactus' element={<ContactUs/>} />
          </Route>
          <Route path='services' element={<ServicesOf />}>
            <Route index element={<ConServices/>}/>
            <Route path='consultingservices' element={<ConServices />} />
            <Route path='/services/TrainQualif' element={<TraQual />} />
            <Route path='/services/najizServices' element={<NajizServices />} />
            <Route path='/services/saberservices' element={<SaberServices />} />
            <Route path='/services/civilservices' element={<CivilDefense />} />
            <Route path='/services/medicalservices' element={<MedicalServices />} />
            <Route path='/services/madad' element={<MadadServices />} />
            <Route path='/services/professionallicense' element={<ProfessionalLicense />} />
            <Route path='/services/agriculturallicense' element={<AgriculturalLicense />} />
            <Route path='/services/proflicesapartner' element={<ProfLicenseSaudPartner />} />
            <Route path='/services/transactivlice' element={<TransportActivitiesLice />} />
            <Route path='/services/forecommlice' element={<ForComLice />} />
            <Route path='/services/coiLissauPar' element={<CoiLisSauPar />} />
            <Route path='/services/prolic' element={<ProLic />} />
            <Route path='/services/indlic' element={<IndLic />} />
            <Route path='/services/unires' element={<UniRes />} />
            <Route path='/services/invbizres' element={<InvBizRes />} />
            <Route path='/services/proownres' element={<ProOwnRes />} />
            <Route path='/services/talres' element={<TalRes />} />
            <Route path='/services/entres' element={<EntRes />} />
            <Route path='/services/excepres' element={<ExcepRes />} />
            {/* ==== */}
            <Route path='/services/manorgevCon' element={<ManOrgEvCon />} />
            <Route path='/services/mansocacc' element={<ManSocAcc />} />
            <Route path='/services/actTabtam' element={<ActTabTam />} />
            <Route path='/services/devweb' element={<DevWeb />} />
            <Route path='/services/upmap' element={<UpMap />} />
            <Route path='/services/raibra' element={<RaiBra />} />
            <Route path='/services/manorgEst' element={<ManOrgEst />} />
            <Route path='/services/propho' element={<ProPho />} />
            <Route path='/services/booAccrec' element={<BooAccRec />} />
            <Route path='/services/prefinadmfin' element={<PreFinAdmFin/>}/>
            <Route path='/services/accsysper' element={<AccSysPer />} />
            <Route path='/services/warinvman' element={<WarInvMan />} />
            <Route path='/services/proacccon' element={<ProAccCon />} />
            <Route path='/services/proaccsys' element={<ProAccSys />} />
            <Route path='/services/settraacc' element={<SetTraAcc />} />
            <Route path='/services/pretaxdec' element={<PreTaxDec />} />
            <Route path='/services/appDev' element={<AppDev />} />
            <Route path='/services/web' element={<Web />} />
            <Route path='/services/technicSupport' element={<TechnicalSupport />} />
            <Route path='/services/hr' element={<Hr />} /> 
            <Route path='/services/accountSys' element={<AccountSystem />} />
            <Route path='/services/AdminSystem' element={<AdminSystem />} />
            <Route path='/services/crm' element={<Crm/>}/>
            <Route path='/services/trademarks' element={<Trademarks/>}/>
            <Route path='/services/patent' element={<Patent/>}/>
            <Route path='/services/indusproduct' element={<IndustrialProduct/>}/>
            <Route path='/services/copyright' element={<Copyright/>}/>
          </Route>
        </Route>
          <Route path='*' element={<ErrorPage/>} />
      </Route>
    )
  );

  return <HelmetProvider>
    <RouterProvider router={router} />
  </HelmetProvider>
}

export default App;